import { useQuery } from "@tanstack/vue-query";

import { explorerApi } from "~/api/client";
import type { NexonLwCirculatingSupplyBreakdownInfo } from "~/api/repository";

export const getCirculatingSupplyBreakdown = () => {
  return useQuery({
    queryKey: ["circulatingSupplyBreakdown"],
    queryFn: () =>
      explorerApi.lwController
        .getCirculatingSupplyBreakdown({ requestBody: {} })
        .then((res) => circulatingSupplyBreakdownDto(res)),
  });
};

export type CirculatingSupplyBreakdownView = {
  circulatingSupply: number;
  burned: number;
  lockedInNeso: SupplyBreakdownItem;
  lockedInFission: SupplyBreakdownItem;
  freeFloat: SupplyBreakdownItem;
};

export type SupplyBreakdownItem = {
  value: number;
  percent: number;
  color: string;
};

// 차트 색상 정의
const SUPPLY_COLORS = {
  lockedInNeso: "#8000ff",
  lockedInFission: "#00c0ff",
  freeFloat: "#00e0c0",
  burned: "#ff6f91",
} as const;

const circulatingSupplyBreakdownDto = (
  data: NexonLwCirculatingSupplyBreakdownInfo
): CirculatingSupplyBreakdownView => {
  const circulatingSupply = Number(data.CSUP);
  const burned = Number(data.BRND);
  const lockedInNeso = Number(data.LNES);
  const lockedInFission = Number(data.LFIS);
  const freeFloat = Number(data.FFLT);

  // 퍼센트 계산 (Circulating Supply 기준)
  const calcPercent = (value: number) =>
    Number(((value / circulatingSupply) * 100).toFixed(1));

  return {
    circulatingSupply,
    burned,
    lockedInNeso: {
      value: lockedInNeso,
      percent: calcPercent(lockedInNeso),
      color: SUPPLY_COLORS.lockedInNeso,
    },
    lockedInFission: {
      value: lockedInFission,
      percent: calcPercent(lockedInFission),
      color: SUPPLY_COLORS.lockedInFission,
    },
    freeFloat: {
      value: freeFloat,
      percent: calcPercent(freeFloat),
      color: SUPPLY_COLORS.freeFloat,
    },
  };
};

// Burned 색상 export (차트에서 사용)
export const BURNED_COLOR = SUPPLY_COLORS.burned;
